/**
 * FERP Portal - Actor List Page (DRR-074: Tabulator DRY Template)
 *
 * CONFIGURE Phase: System actors (users, services, bots) participating in workflows.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function ActorListPage() {
  return <TabulatorPrimitiveManager primitiveType="actor" />;
}

export default ActorListPage;
